import React from 'react';
import Hero from '../components/Hero';
import Mission from '../components/Mission';
import CustodyGap from '../components/CustodyGap';
import WhyNow from '../components/WhyNow';
import JoinCTA from '../components/JoinCTA';

export default function AboutUs() {
  return (
    <>
      <Hero />
      <Mission />
      <CustodyGap />
      <WhyNow />
      <JoinCTA />
    </>
  );
}
